module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "admin-table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((14), function(n) {
    return _c('tr', [_c('td', [_vm._v("Phelix Systems")]), _vm._v(" "), _c('td', [_vm._v("Phelix@email.com")]), _vm._v(" "), _c('td', [_vm._v("09986573838")]), _vm._v(" "), _c('td', [_vm._v("Phelix Max")]), _vm._v(" "), _c('td', [_vm._v("AST")]), _vm._v(" "), _vm._m(2, true)])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("Suppliers")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Supplier"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("PO Format")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Contact #")]), _vm._v(" "), _c('th', [_vm._v("Contact Person")]), _vm._v(" "), _c('th', [_vm._v("PO Format")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "admin-table-row-options"
  }, [_c('button', [_vm._v("Edit Account")]), _vm._v(" "), _c('button', [_vm._v("Delete Account")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b0c088"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminSuppliers.vue
// module id = 142
// module chunks = 0